var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4958 2H8.49585C7.39585 2 6.49585 2.9 6.49585 4V16C6.49585 17.1 7.39585 18 8.49585 18H20.4958C21.5958 18 22.4958 17.1 22.4958 16V4C22.4958 2.9 21.5958 2 20.4958 2ZM20.4958 16H8.49585V4H20.4958V16ZM4.49585 6H2.49585V20C2.49585 21.1 3.39585 22 4.49585 22H18.4958V20H4.49585V6ZM16.4958 12V9C16.4958 8.45 16.0458 8 15.4958 8H13.4958V13H15.4958C16.0458 13 16.4958 12.55 16.4958 12ZM14.4958 9H15.4958V12H14.4958V9ZM18.4958 11H19.4958V10H18.4958V9H19.4958V8H17.4958V13H18.4958V11ZM10.4958 11H11.4958C12.0458 11 12.4958 10.55 12.4958 10V9C12.4958 8.45 12.0458 8 11.4958 8H9.49585V13H10.4958V11ZM10.4958 9H11.4958V10H10.4958V9Z",
    fill: "#016AD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4b43ab7551ce3af2e9f73a38c417099c.svg";
export { ForwardRef as ReactComponent };